import * as React from "react";
import type { JSX } from 'react';
import { connect } from "react-redux";
import * as Redux from "redux";
import { AnyAction, Dispatch } from "redux";
import { activateMail } from "../../../business/Auth/AuthEpics";
import { LegacyMatch, withMatch } from "../../../business/router/with-match";

interface IVerifyMailPageContainerReduxMergedProps {
  match: LegacyMatch<{ guid?: string }>;
}

interface IVerifyMailPageContainerOwnProps {}

interface IVerifyMailPageContainerDispatchProps {
  activateMail: (guid: string) => void;
}

interface IVerifyMailPageContainerProps
  extends IVerifyMailPageContainerOwnProps,
    IVerifyMailPageContainerDispatchProps,
    IVerifyMailPageContainerReduxMergedProps {}

interface IVerifyMailPageComponentState {}

class VerifyMailPageContainer extends React.Component<
  IVerifyMailPageContainerProps,
  IVerifyMailPageComponentState
> {
  constructor(
    props: IVerifyMailPageContainerProps,
    state: IVerifyMailPageComponentState
  ) {
    super(props, state);
    this.state = this.getInitialState();
    const guid = this.props.match.params.guid!;
    props.activateMail(guid);
  }

  public render(): JSX.Element {
    return <></>;
  }

  public static mapDispatchToProps = (
    dispatch: Dispatch<AnyAction>
  ): IVerifyMailPageContainerDispatchProps => {
    return {
      ...Redux.bindActionCreators(
        {
          activateMail: activateMail,
        },
        dispatch
      ),
    };
  };

  private getInitialState = (): IVerifyMailPageComponentState => {
    return {} as IVerifyMailPageComponentState;
  };
}
export const VerifyMailPageLogic = withMatch(
  connect(
    null,
    VerifyMailPageContainer.mapDispatchToProps
  )(VerifyMailPageContainer) as unknown as React.ComponentType<{
    match: LegacyMatch<{ guid?: string }>;
  }>
);
